import React, { useState, useEffect } from "react";
import {
  collection,
  getDocs,
  query,
  where,
  Timestamp,
  orderBy,
  doc,
  getDoc,
} from "firebase/firestore";
import { db } from "../Config/Firebase";

const PAGE_SIZE = 12;

const FeeDetailsList = () => {
  const [allPayments, setAllPayments] = useState([]); 
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);

  const fetchAllPayments = async () => {
  try {
    setLoading(true);

    const now = new Date();
    const twoDaysAgo = new Date(now);
    twoDaysAgo.setDate(now.getDate() - 2);
    const twoDaysAgoTimestamp = Timestamp.fromDate(twoDaysAgo);

    const q = query(
      collection(db, "walletLogs"),
      where("createdAt", ">=", twoDaysAgoTimestamp),
      orderBy("createdAt", "desc")
    );

    const snapshot = await getDocs(q);

    const paymentsWithUser = await Promise.all(
      snapshot.docs.map(async (docSnap) => {
        const paymentData = docSnap.data();

        let userData = {};
        //Fetch Users Dta
        if(!paymentData.userId ){  
          const userRef = doc(db, "users", paymentData.user_id);
          const userSnap = await getDoc(userRef);
          userData = userSnap.exists() ? userSnap.data() : {};
        }else{
          const userRef = doc(db, "users", paymentData.userId);
          const userSnap = await getDoc(userRef);
          userData = userSnap.exists() ? userSnap.data() : {};
        }

        return {
                id: docSnap.id,
                amount: paymentData.amount,
                fromAmount: paymentData.amountBefore || paymentData.fromAmount,
                toAmount: paymentData.amountAfter || paymentData.toAmount,
                type: paymentData.transactionType || paymentData.type ,
                createdAt: paymentData.createdAt, 
                userName: userData.name || "Unknown User",
                userEmail: userData.email || "",
                mobile: userData.mobile || "",
                profileImageUrl: userData.profileImageUrl || "",
                reason: paymentData.reason || paymentData.type || "N/A",
              };
      })
    );

    setAllPayments(paymentsWithUser);
  } catch (err) {
    console.error("Error fetching payments:", err);
  } finally {
    setLoading(false);
  }
};


  useEffect(() => {
    fetchAllPayments();
  }, []);

  if (loading) return <p className="text-gray-600">Loading payments...</p>;

  const totalPages = Math.ceil(allPayments.length / PAGE_SIZE);

  const startIndex = (currentPage - 1) * PAGE_SIZE;
  const currentPayments = allPayments.slice(startIndex, startIndex + PAGE_SIZE);

  return (
    <div className="Fee-Details-Container ">
      <h1 className="text-xl font-semibold mb-4">Last 2 Days Payment List</h1>

      {currentPayments.length > 0 ? (
        <div className="Student-List overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-gray-100">
              <tr>
                <th className="p-2 text-left ">Name</th>
                <th className="p-2 text-left ">Amount <br />(Debit / Credit)</th>
                <th className="p-2 text-left ">Account Balance</th>
                <th className="p-2 text-left ">Reason</th>
              </tr>
            </thead>
            <tbody>
              {currentPayments.map((payment) => (
                <tr key={payment.id} className="hover:bg-gray-50">
                  <td className="p-2 border">{payment.userName}</td>
                  <td
                  className={`p-2 border ${
                    payment.type === "DEBIT" || payment.type === "TEXT_CHAT_DEDUCTION" ? "text-red-500"  : "text-green-500"

                  }`}
                >
                  {payment.type === "DEBIT" || payment.type === "TEXT_CHAT_DEDUCTION"
                    ? `- ${payment.amount}`
                    : `+ ${payment.amount}`}
                </td>
                  
                  <td className="p-2 border">{payment.toAmount}</td>
                  <td className="p-2 border">{payment.reason}</td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Pagination */}
          <div className="flex justify-center items-center gap-4 mt-4">
            <button
              onClick={() => setCurrentPage((p) => p - 1)}
              disabled={currentPage === 1}
              className="px-3 py-1 border rounded disabled:opacity-50 hover:bg-gray-100"
            >
              Prev
            </button>
            <span className="text-sm text-gray-600">
              Page {currentPage} / {totalPages}
            </span>
            <button
              onClick={() => setCurrentPage((p) => p + 1)}
              disabled={currentPage === totalPages}
              className="px-3 py-1 border rounded disabled:opacity-50 hover:bg-gray-100"
            >
              Next
            </button>
          </div>
        </div>
      ) : (
        <p className="text-gray-600">No payments found for the last 2 days.</p>
      )}
    </div>
  );
};

export default FeeDetailsList;

const formatDateTime = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (isNaN(date.getTime())) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};